<script setup>
import Modal from '../../Modal.vue';

defineProps({
  onClose: { type: Function, default: () => {} },
  onConfirm: { type: Function, default: () => {} },
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  messageValue: { type: String, default: '' },
  confirmText: { type: String, default: '' },
  rejectText: { type: String, default: '' },
  // 添加 loading 实现，默认不显示
  hasConfirmLoading: { type: Boolean, default: false }, // 是否显示loading状态
});

const show = defineModel('show', { type: Boolean, default: false });
</script>

<template>
  <Modal v-model:show="show" :on-close="onClose">
    <woot-modal-header
      :header-title="title"
      :header-content="message"
      :header-content-value="messageValue"
    />
    <div class="flex items-center justify-end gap-2 p-8">
      <woot-button variant="clear" class="action-button" @click="onClose">
        {{ rejectText }}
      </woot-button>
      
      <!-- 原有的按钮，当不需要loading时使用 -->
      <woot-button
        v-if="!hasConfirmLoading"
        color-scheme="alert"
        class="action-button"
        variant="smooth"
        @click="onConfirm"
      >
        {{ confirmText }}
      </woot-button>
      
      <!-- 当需要loading时使用自定义按钮 -->
      <!-- 右侧loading按钮 -->
      <button
        v-if="hasConfirmLoading"
        class="button action-button alert smooth loading-button"
        :disabled="hasConfirmLoading"
        @click="onConfirm"
      >
        <span class="button__content text-left rtl:text-right">
          {{ confirmText }}
        </span>
        <span class="ml-0">
          <span class="custom-spinner" :style="{'--spinner-color': '#0055ff','--spinner-bg-color': '#ffffff'}">
          </span>
        </span>
      </button>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
.action-button {
  max-width: var(--space-giga);
}

.loading-button {
  &:disabled {
    opacity: 0.85; // 降低禁用状态的不透明度，使内容更清晰
    
    // 确保禁用状态下 spinner 仍然清晰可见
    .custom-spinner {
      opacity: 1;
    }
  }
}

.custom-spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 2px solid;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
  margin-bottom: 3px; // 微调垂直位置，使其与文本在同一水平线上
  border-top-color: var(--spinner-color, #0055ff) !important;
  border-color: var(--spinner-bg-color, #ffffff);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
